import GroupEditingLayout from "components/templates/QueryBuilder/GroupEditingLayout";
import AfterSaveModal from "components/templates/QueryBuilder/GroupEditingLayout/AfterSaveModal";
import { getGroupIdAfterSaveGroupAtom } from "components/templates/QueryBuilder/groupEditingState";
import getTestIDs from "lib/utils/getTestIDs";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { currentDeviceTab } from "../../deviceTabsState";

export const testIDs = getTestIDs();

const DeviceGroupEditing: React.FC<{}> = () => {
  const history = useHistory();
  const setCurrentTab = useSetRecoilState(currentDeviceTab);
  const { deviceGroupId }: { deviceGroupId: string } = useParams();
  const groupIdAfterSaveGroup = useRecoilValue(getGroupIdAfterSaveGroupAtom);

  const seeAllDeviceGroups = () => {
    setCurrentTab(1);
    history.push("/deviceManagement");
  };

  const seeDeviceGroupDetails = () => {
    // Until dedicated device group details are available, return to device groups.
    if (groupIdAfterSaveGroup) {
      history.push("/deviceManagement");
    }
  };

  return (
    <>
      <GroupEditingLayout
        entityName="Device"
        handleGoToAllGroups={seeAllDeviceGroups}
        handleGoToGroup={seeDeviceGroupDetails}
        groupId={deviceGroupId}
      />
      <AfterSaveModal
        entityName="Device"
        handleGoToAllGroups={seeAllDeviceGroups}
        handleGoToGroup={seeDeviceGroupDetails}
        isEditing={!!deviceGroupId}
      />
    </>
  );
};

export default DeviceGroupEditing;
